import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import Icon from '@cld/icon';
import Popover from '@cld/popover';
import theme from '@cld/theme-helper';
import Tooltip from '@cld/tooltip';
import { messages } from '../../../i18n';
import { PopoverOverlay } from './PopoverOverlay';

const PopoverWrapper = styled.div`
  cursor: pointer;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${theme`color.gray40`};
  }
`;

const PopoverIcon = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin: ${theme`spacing.sm`};
`;

export const ItemOverlay = ({ onClick, urlForCopy, urlForDownload }) => {
  const { formatMessage } = useIntl();
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const menuButtonRef = useRef();

  const handleMenuIconClick = (event) => {
    event.stopPropagation();
    setIsTooltipVisible(false);
  };
  const handleMouseLeave = () => setIsPopoverVisible(false);
  const handleTooltipVisibleChange = (visible) => setIsTooltipVisible(!isPopoverVisible && visible);

  return (
    <PopoverWrapper onClick={onClick} onMouseLeave={handleMouseLeave}>
      <Popover
        destroyTooltipOnHide
        getTooltipContainer={() => menuButtonRef.current}
        onVisibleChange={setIsPopoverVisible}
        overlay={<PopoverOverlay urlForCopy={urlForCopy} urlForDownload={urlForDownload} />}
        paperProps={{ padded: false }}
        placement="bottom"
        trigger="click"
        visible={isPopoverVisible}
      >
        <PopoverIcon onClick={handleMenuIconClick} ref={menuButtonRef} data-test="menu-button">
          <Tooltip onVisibleChange={handleTooltipVisibleChange} visible={isTooltipVisible} title={formatMessage(messages.menu)}>
            <Icon name="moreVert" size="sm" />
          </Tooltip>
        </PopoverIcon>
      </Popover>

      <Icon name="eyeOn" size="xl" />
    </PopoverWrapper>
  );
};

ItemOverlay.propTypes = {
  onClick: PropTypes.func.isRequired,
  urlForCopy: PropTypes.string.isRequired,
  urlForDownload: PropTypes.string.isRequired,
};
